<script setup lang="ts"></script>

<template>
  <div class="card p-4 xl:px-6">
    <div class="card-content h-full">
      <slot></slot>
    </div>
  </div>
</template>
